/* Timezone — время показываем в ВЫБРАННОЙ зоне, ровно как строятся фильтры по дате */
import { inTz, nowInTz } from "../../helpers/timezone"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"


/* HOW MANY FACES THE PANEL HAS — /images/player/gamer1..gamer11 */
const AVATARS = 11


/* AVATAR OF A PLAYER — THE SAME CODE ALWAYS GETS THE SAME FACE
 * The picture is not stored anywhere, so it is taken from the code of the player instead of a random
 * number: otherwise every row of the same player would draw a different face on every render. */
export const getAvatar = (item) => {

    /* Check Tester — a test account has a face of its own */
    if (parseInt(item.isTester) === 1) {
        return utils.ava(0, "test")
    }

    /* Fields */
    const code = String(item.player ? item.player : "")
    let hash = 0

    /* Hash Of The Code */
    for (let index = 0; index < code.length; index++) {
        hash = (hash * 31 + code.charCodeAt(index)) % AVATARS
    }

    /* Send Result */
    return utils.ava(hash, "")
}


/* STATE OF A TRANSACTION — 0 IS PENDING, 1 IS SUCCESSFUL, 2 IS FAILED */
export const getState = (value) => {

    /* Success */
    if (parseInt(value) === 1) {
        return "success"
    }

    /* Failed */
    if (parseInt(value) === 2) {
        return "failed"
    }

    /* Send Result */
    return "pending"
}


/* NAME OF THE STATE */
export const getStateText = (value) => {

    /* Fields */
    const state = getState(value)

    /* Success */
    if (state === "success") {
        return t("gtx.success")
    }

    /* Failed */
    if (state === "failed") {
        return t("gtx.failed")
    }

    /* Send Result */
    return t("gtx.pending")
}


/* NAME OF A GAME — A TABLE MAY ALREADY BE DELETED, THEN THE SLUG IS ALL WE HAVE */
export const getGame = (item) => {

    /* Check Name */
    if (item.game) {
        return item.game
    }

    /* Check Slug */
    if (item.table) {
        return item.table
    }

    /* Send Result */
    return t("gtx.noGame")
}


/* CURRENCY OF A TRANSACTION — THE COLUMN KEEPS IT IN ANY CASE */
export const getCurrency = (value) => value ? String(value).toUpperCase() : ""


/* AMOUNT THAT MAY BE MISSING — THE OPERATOR DOES NOT ALWAYS SEND THE BALANCE */
export const isEmpty = (value) => value === null || value === undefined || value === ""


/* PLAIN NUMBER OF THE STATS — A COUNTER IS WHOLE, ONLY THE MONEY KEEPS THE CENTS */
export const formatCount = (value) => {

    /* Fields */
    const number = parseInt(value)

    /* Check Value */
    if (isNaN(number)) {
        return "0"
    }

    /* Send Result */
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}


/* DAY OF A TRANSACTION */
export const formatDay = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY")
}


/* TIME OF A TRANSACTION — THE MONEY IS READ BY THE SECOND, NOT BY THE MINUTE */
export const formatTime = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("HH:mm:ss")
}


/* FULL DATE OF A TRANSACTION */
export const formatDate = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY HH:mm:ss")
}


/* HOW LONG AGO IT HAPPENED
 * The units are abbreviations on purpose — they need no plural agreement in any language,
 * and anything older than two months is shown as a plain date instead. */
export const formatAgo = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Fields */
    const minutes = nowInTz().diff(inTz(value), "minutes")

    /* Check Future — the clock of a game server may run ahead of the panel */
    if (minutes < 1) {
        return t("log.ago.now")
    }

    /* Minutes */
    if (minutes < 60) {
        return `${minutes} ${t("log.ago.minutes")} ${t("log.ago.suffix")}`
    }

    /* Hours */
    if (minutes < 60 * 24) {
        return `${Math.floor(minutes / 60)} ${t("log.ago.hours")} ${t("log.ago.suffix")}`
    }

    /* Days */
    if (minutes < 60 * 24 * 60) {
        return `${Math.floor(minutes / (60 * 24))} ${t("log.ago.days")} ${t("log.ago.suffix")}`
    }

    /* Send Result */
    return formatDay(value)
}
